import {
  HttpInterceptorFn
} from '@angular/common/http';

export const userInterceptor: HttpInterceptorFn = (req, next) => {
  
  const raw = localStorage.getItem('USER');
  if (!raw) return next(req);

  try {
    const user = JSON.parse(raw);
    const token = user?.token;
  
    if (!token) return next(req);

    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(cloned);
  } catch {
    return next(req);
  }
};